import React from "react";
import ConnectorPanel from "./ConnectorPanel";

// Atera. Everything except the credential field and the copy comes from ConnectorPanel.
//
// One field: Atera authenticates with a single account-wide API key, and the base URL is
// pinned server-side to app.atera.com rather than being asked for — a configurable host
// on a stored credential is a way to point that credential at somewhere else.

const FIELDS = [
  {
    key: "api_key",
    label: "API key",
    secret: true,
    required: true,
    help: "Atera → Admin → API. The key is account-wide and read-only access is enough.",
  },
];

const HELP = {
  summary: "Match scanned hosts to Atera agents and pull their asset and patch detail.",
  customerNoun: "Atera customer",
  steps: [
    "In Atera, open Admin → API.",
    "Generate an API key if there is not one already.",
    "Paste it here and press Connect, then Test connection.",
  ],
};

const AteraPanel = ({ isAdmin }) => (
  <ConnectorPanel
    isAdmin={isAdmin}
    provider="atera"
    title="Atera"
    fields={FIELDS}
    help={HELP}
  />
);

export default AteraPanel;
